<template>
  <ButtonSquare
    :title="$t('general__view__model')"
    :imgSource="require('@/assets/icon-model.svg')"
    size="large"
    :activeState="activeState"
    :hoverButtons="hoverButtons"
    :activeHoverButtonValue="currentModel"
    :showLoadingSpinner="isLoadingModel"
    @clicked="onClick"
    @onHoverButtonClick="changeModel"
    @mouseenter="onHover"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { SET_CURRENT_MODEL } from '@/store/mutation-types'
import { MAPVIEW_PREFIX, PLANVIEW_PREFIX } from '@/store/module-prefixes'
import { setViewToModelview, setViewToPlanview } from '@/utils/views'
import { zoomToEntities } from '@/composables/useMapbox'

export default {
  name: 'ModelButton',
  components: {
    ButtonSquare
  },
  emits: ['ModelButtonHovered'],
  computed: {
    hoverButtons() {
      const hoverButtons = []
      if (!this.selectedLevel?.models3d.length) return hoverButtons
      this.selectedLevel.models3d.forEach((el, index) => {
        hoverButtons.push({
          title: el.title
            ? el.title
            : el.model3dType.charAt(0).toUpperCase() +
              el.model3dType.replaceAll('_', ' ').slice(1).toLowerCase(),
          emit: `${el.model3dType}_MODEL_${index}`
        })
      })
      // Make ARCHITECTURAL_MODEL appear first if available
      const index = hoverButtons.findIndex(
        (el, index) => el.emit === `ARCHITECTURAL_MODEL_${index}`
      )
      if (index !== -1) {
        const obj = hoverButtons.splice(index, 1)
        hoverButtons.push(obj[0])
      }
      return hoverButtons
    },
    activeState() {
      if (this.hoverButtons && this.hoverButtons.length && !this.isDrawPointActive) {
        return this.isModelviewShowing ? 'active' : 'inactive'
      }
      return 'deactivated'
    },
    ...mapGetters({
      isDrawPointActive: 'isDrawPointActive',
      isModelviewShowing: 'isModelviewShowing',
      isPlanviewShowing: 'isPlanviewShowing',
      selectedLevelId: 'selectedLevelId'
    }),
    ...mapState({
      previousView: (state) => state.previousView,
      selectedLevel: (state) => state.selectedLevel
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedBuilding: (state) => state.selectedBuilding
    }),
    ...mapState(PLANVIEW_PREFIX, {
      currentModel: (state) => state.currentModel,
      isLoadingModel: (state) => state.isLoadingModel
    })
  },
  watch: {
    hoverButtons: {
      immediate: true,
      handler() {
        if (this.hoverButtons.length) {
          this.setCurrentModel({
            type: this.hoverButtons[this.hoverButtons.length - 1].emit
          })
        } else {
          this.setCurrentModel({
            type: null
          })
        }
      }
    }
  },
  methods: {
    async onClick() {
      if (this.activeState === 'deactivated') return null
      !this.isModelviewShowing ? setViewToModelview() : setViewToPlanview()
      const featureObject = {
        type: 'Feature',
        id: this.selectedBuilding.id,
        geometry: this.selectedBuilding.geometry,
        properties: {
          ...this.selectedBuilding
        }
      }
      zoomToEntities([featureObject.id])
    },
    changeModel(value) {
      this.setCurrentModel({ type: value })
      if (!this.isModelviewShowing) this.onClick()
    },
    onHover() {
      if (this.activeState !== 'deactivated') {
        this.$emit('ModelButtonHovered')
      }
    },
    ...mapMutations(PLANVIEW_PREFIX, {
      setCurrentModel: SET_CURRENT_MODEL
    })
  }
}
</script>

<style lang="scss" scoped></style>
